module.exports = __webpack_public_path__ + "img/BRAVO_3.adf71fc1.jpg";